import React from "react";

export default function About() {
  return (
    <section className="about">
      <div className="auto__container">
        <div className="about__inner np">
          <div className="about__inner-image-wrapper">
            <div className="about__inner-image">
              <img
                src={process.env.PUBLIC_URL + "/images/about/4.png"}
                alt=""
              />
            </div>
          </div>
          <div className="about__inner-image-wrapper">
            <div className="about__inner-image">
              <img
                src={process.env.PUBLIC_URL + "/images/about/5.png"}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
